import { createSlice } from "@reduxjs/toolkit";
import { auth } from "../../models/auth/auth.models";

const estadoInicial: auth = {
    correo: "",
    nombreUsuario: ""
};

const authSlice = createSlice({
    name: 'auth',
    initialState: estadoInicial,
    reducers: {
        nuevoInicioSesion: (_state, action) => {
            return action.payload;
        },
        cerrarSesion: () => {
            return estadoInicial;
        }
    }
});

export const { nuevoInicioSesion, cerrarSesion } = authSlice.actions;

export default authSlice.reducer;
